import { FC } from 'react';
import { Product } from '@setvi/shared/interfaces';
import { ProductEnhancer } from 'componentsV2/product/details/content/subpages';
import { EnhanceContentWrapper, EnhanceDialogWrapper } from './styled';
import { EnhancerDialogHeader } from './components';

interface EnhanceDialogProps {
  product: Product;
  onCloseClick: () => void;
}

export const ProductEnhancerEnhanceDialog: FC<EnhanceDialogProps> = ({
  product,
  onCloseClick
}) => (
  <EnhanceDialogWrapper>
    <EnhancerDialogHeader onCloseClick={onCloseClick} product={product} />
    <EnhanceContentWrapper>
      <ProductEnhancer product={product} />
    </EnhanceContentWrapper>
  </EnhanceDialogWrapper>
);
